import axios from "axios";
import  { API_JAVA } from '../config';
const BASE_URL = API_JAVA;

class AdminService{

    // getKeySettings() {
    //     return axios.get(`${BASE_URL}/pre-auth`);
    // }

    getAdmin(result) {
        return axios.post(`${BASE_URL}/admin/auth`, { result }, {withCredentials: true});
    }
    getAdminProfile() {
        return axios.get(`${BASE_URL}/admin/profile`, {withCredentials: true});
    }
    getNCALayerModuleRequests() {
        return axios.get(`${BASE_URL}/admin/requests`, {withCredentials: true});
    }
    postAdminEmail(email) {
        return axios.post(`${BASE_URL}/admin/editAdminEmail`, { email }, {withCredentials: true});
    }
    postDevEmail(email) {
        return axios.post(`${BASE_URL}/admin/editDevEmail`, { email }, {withCredentials: true});
    }
    getDevEmail() {
        return axios.get(`${BASE_URL}/admin/getDevEmail`, {withCredentials: true});
    }
    getNCALayerModuleFile(id) {
        return axios.get(`${BASE_URL}/admin/download/${id}`, {
            responseType: 'blob',
            withCredentials: true
          });
    }
    rejectRequest = async (requestId, reason) => {
      try {
          const response = await axios.post(`${BASE_URL}/admin/nm-request/reject`, null, {
              params: {
                  requestId: requestId,
                  reason: reason,
              },
              withCredentials: true, // Добавлено здесь
          });
          console.log('Заявка отклонена успешно');
      } catch (error) {
          console.error('Ошибка при отклонении заявки:', error);
          throw error;
      }
  };
  
  confirmRequest = async (requestId) => {
      try {
          const response = await axios.post(`${BASE_URL}/admin/nm-request/confirm`, null, {
              params: {
                  requestId: requestId,
              },
              withCredentials: true, // Добавлено здесь
          });
          console.log('Заявка подтверждена успешно');
      } catch (error) {
          console.error('Ошибка при подтверждении заявки:', error);
          throw error;
      }
  };
  
  closeRequest = async (requestId) => {
      try {
          const response = await axios.post(`${BASE_URL}/admin/nm-request/close`, null, {
              params: {
                  requestId: requestId,
              },
              withCredentials: true, // Добавлено здесь
          });
          console.log('Заявка закрыта успешно');
      } catch (error) {
          console.error('Ошибка при закрытии заявки:', error);
          throw error;
      }
  };
  
      getSDKReports() {
        return axios.get(`${BASE_URL}/admin/sdk-reports`, {
          responseType: 'blob',
          withCredentials: true
       }, {withCredentials: true});
      

    }
    getNMReports() {
      return axios.get(`${BASE_URL}/admin/nm-reports`, {
        responseType: 'blob',
        withCredentials: true
     });
    }
}

export default new AdminService();
